import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-refresh-button',
  imports: [LucideAngularModule],
  template: `
    <button
      type="button"
      [class]="
        prominent()
          ? 'tw-button inline-flex h-10 w-auto shrink-0 items-center justify-center gap-1.5 rounded-2xl border border-[var(--theme-color)] bg-[var(--theme-color)] px-2.5 text-white shadow-lg transition hover:border-[var(--theme-hover)] hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--theme-color)] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50'
          : 'tw-button inline-flex h-8 w-auto shrink-0 items-center justify-center gap-1.5 rounded-xl border border-slate-200 bg-white px-2.5 text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50'
      "
      [title]="label()"
      [attr.aria-label]="label()"
      [disabled]="loading()"
      (click)="refresh.emit()"
    >
      <lucide-icon
        name="RefreshCw"
        [size]="prominent() ? 16 : 12"
        [class.animate-spin]="loading()"
      />
      <span
        [class]="
          prominent()
            ? 'text-[13px] font-semibold whitespace-nowrap'
            : 'text-[11px] font-medium whitespace-nowrap'
        "
        >รีเฟรช</span
      >
    </button>
  `,
})
export class RefreshButtonComponent {
  readonly loading = input(false);
  readonly label = input('รีเฟรช');
  readonly prominent = input(false);
  readonly refresh = output<void>();
}
